import { type StatesList } from '@tdwb/webbroker/core';
import { SiteWideSearchComponent } from './site-wide-search.component';

export class SiteWideSearchRoutes {
  static states: StatesList = [
    {
      name: 'modal.search',
      url: '/search',
      data: {
        modalOptions: {
          component: SiteWideSearchComponent,
          size: 'full-screen',
          closeOnEscapeKey: true,
          autoFocus: false
        }
      }
    }
  ];
}
